import { gql } from "@apollo/client";
export const allPoolsQueryVars = {
    skip: 0,
    first: 10,
};

export const ALL_POOLS_QUERY = gql`
    query PoolEvents {
        poolEvents {
            _id
            description
            maxWinnerApplyWhitelist
            maxWinnerSwapToken
            maxAllocationAltCoin
            competitionPeriodStartAt
            competitionPeriodEndAt
            whitelistPeriodStartAt
            whitelistPeriodEndAt
            swapTokenPeriodStartAt
            swapTokenPeriodEndAt
            claimTokenPeriodStartAt
            pool {
                title
            }
            whitelists {
                customerAddress
                isWinner
                isPurchased
                isContributed
                buyAmount
            }
            claimTokenPolicy
            claimTGEPercent
            vestingTimes
            pricePerToken
            availableAmountToken
            contributeAmountToken
            updatedAt
        }
    }
`;

export const POOL_DETAIL_QUERY = gql`
    query poolEvent($id: String!) {
        poolEvent {
            _id
            description
            maxWinnerApplyWhitelist
            maxWinnerSwapToken
            maxAllocationAltCoin
            competitionPeriodStartAt
            competitionPeriodEndAt
            whitelistPeriodStartAt
            whitelistPeriodEndAt
            swapTokenPeriodStartAt
            swapTokenPeriodEndAt
            claimTokenPeriodStartAt
            pool {
                title
            }
            whitelists {
                customerAddress
            }
            vestingSchedules {
                isVested
            }
            updatedAt
        }
    }
`;

export const BUY_SEED_MUTATION = gql`
    mutation UpdatePurchaseWhitelist(
        $customerId: String!
        $customerAddress: String!
        $poolEventId: String!
        $isPurchased: Boolean
        $buyAmount: Int
        $id: String!
    ) {
        updatePurchaseWhitelist(
            whitelist: {
                customerId: $customerId
                customerAddress: $customerAddress
                poolEventId: $poolEventId
                isPurchased: $isPurchased
                buyAmount: $buyAmount
            }
            id: $id
        ) {
            _id
            customerAddress
            isWinner
            isPurchased
            createdAt
            customer {
                email
                address
            }
            poolEvent {
                description
                pricePerToken
            }
        }
    }
`;

export const CLAIM_TOKEN_QUERY = gql`
    mutation UpdateVestingSchedule($id: String!, $isVested: Boolean) {
        updateVestingSchedule(id: $id, isVested: $isVested) {
            _id
            customerAddress
            customer {
                email
            }
            poolEvent {
                description
            }
            amount
            ratingPercent
            vestingAt
            isVested
        }
    }
`;

export const ALL_POOLS_QUERY_ver2 = gql`
    query PoolEvents {
        poolEvents {
            _id
            description
            maxWinnerApplyWhitelist
            maxWinnerSwapToken
            maxAllocationAltCoin
            competitionPeriodStartAt
            competitionPeriodEndAt
            whitelistPeriodStartAt
            whitelistPeriodEndAt
            swapTokenPeriodStartAt
            swapTokenPeriodEndAt
            claimTokenPeriodStartAt
            whitelistWinnerAnnouncementAt
            acceptedCurrency
            pool {
                title
            }
            contracts {
                seed
                vesting
                mnd
                acceptedToken
            }
            whitelist {
                formLink
                resultLink
            }
            whitelists {
                customerAddress
                isWinner
                isPurchased
                isContributed
                buyAmount
            }
            claimTokenPolicy
            claimTGEPercent
            vestingTimes
            pricePerToken
            availableAmountToken
            contributeAmountToken
            updatedAt
        }
    }
`;
